import type { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

export const GridComponent: RegisteredComponent = {
  name: "Grid",
  component: dynamic(() => import("./Grid").then((mod) => mod.Grid)),
  inputs: [
    {
      name: "columnDesktopWidth",
      type: "string",
      enum: ["3", "4", "6", "12"],
      defaultValue: "4",
      required: true,
    },
    {
      name: "columnTabletWidth",
      type: "string",
      enum: ["3", "4", "6", "12"],
    },
  ],
  canHaveChildren: true,
  noWrap: true,
  shouldReceiveBuilderProps: {
    builderBlock: true,
    builderComponents: true,
    builderContext: true,
  },
};
